import { Modal as AntdModal, type ModalProps as AntdModalProps, type ModalFuncProps } from 'antd';

export type ModalProps = AntdModalProps;

const DEFAULTS = {
  destroyOnHidden: true,
  footer: null,
  mask: { blur: false, closable: false },
} satisfies Partial<AntdModalProps>;

export const Modal = (props: ModalProps) => <AntdModal {...DEFAULTS} {...props} />;

export const confirm = (modalProps: ModalFuncProps) =>
  AntdModal.confirm({
    icon: null,
    okText: 'Confirm',
    mask: { blur: false },
    ...modalProps,
  });
